import { RenderListItem } from '../../api/rendersApi';

export function approvedRenderIdsForPair(
  renders: RenderListItem[],
  pair: { householdId: string; listenerId: string; voiceId: string }
): string[] {
  return renders
    .filter((render) => render.status === 'parent_approved')
    .filter((render) => render.household_id === pair.householdId && render.listener_id === pair.listenerId && render.voice_id === pair.voiceId)
    .map((render) => render.render_id);
}
export function filterToHandoff(
  renders: RenderListItem[],
  session: { householdId: string; listenerId: string; voiceId: string; allowedRenderIds: string[] }
): RenderListItem[] {
  const allowed = new Set(session.allowedRenderIds);
  return renders.filter((render) =>
    allowed.has(render.render_id) &&
    render.status === 'parent_approved' &&
    render.household_id === session.householdId &&
    render.listener_id === session.listenerId &&
    render.voice_id === session.voiceId
  );
}
